import { computed, toValue } from "vue";
import { useCartMutationVariables } from "@/core/api/graphql/cart/composables";
import { useMutation } from "@/core/api/graphql/composables";
import { ReorderCartItemsDocument } from "@/core/api/graphql/types";
import type { CartIdFragment } from "@/core/api/graphql/types";
import type { MaybeRef } from "vue";

export function useReorderCartItemsMutation(cart?: MaybeRef<CartIdFragment | undefined>) {
  const baseOptions = useCartMutationVariables(cart);
  // skipQuery: false — refetch the cart so the Apollo cache gets updated sortOrderTL values,
  // which allows the minicart (and any other consumer of availabilityItems) to reflect the new order.
  const options = computed(() => {
    const base = toValue(baseOptions);
    return {
      ...base,
      variables: { ...base.variables, skipQuery: false } as typeof base.variables,
    };
  });
  return useMutation(ReorderCartItemsDocument, options);
}
